<template lang="pug">
  v-content
      v-navigation-drawer.d-print-none( permanent v-model='drawer' :mini-variant.sync='mini' app  )
        v-list-item
          v-list-item-avatar
            v-img( :src='$store.state.Customers.data.logoUrl' )
          v-list-item-title {{$store.state.Customers.data.name}}            
          v-spacer
          v-btn(icon  @click.stop='mini = !mini' color='primary')
            v-icon fas fa-chevron-left
        v-divider
        v-list(dense)
          template(v-for='item in recordMain')
            v-list-item(:to='{ name: item.routerName, params: { customerName: $route.params.customerName}}' @click.stop='mini = !mini')
              v-list-item-icon( @click='mini = false')
                v-icon {{ item.icon }}
              v-list-item-content
                v-list-item-title {{ item.name }}           
          v-list-item( data-toggle="modal" @click='logOut()')
            v-list-item-icon
              v-icon.fas.fa-sign-out-alt
            v-list-item-content    
              v-list-item-title Cerrar Sesión 
        
    
    
      v-container(fluid)
        v-fade-transition( mode="out-in" )
          router-view(fill-height)
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import {mainAuth, credential} from '@/FirebaseConfig.js'
export default {
  data: ()=>({
    drawer:true,

    mini: true,
    
  }),
  methods:  {
    ...mapActions({
      setCustomer: 'Customers/setCustomer',
      getAllDocuments: 'Customers/getAllDocuments',
      logOut: 'Users/logOut'
    }),
    
    
  },
  computed:{
    ...mapGetters({
      recordMain:'Privileges/recordMain',
    }),
    
  },
  created(){
    this.setCustomer(this.$route.params.customerName).then(()=>{
      this.getAllDocuments()
      this.$vuetify.theme.primary = this.$store.state.Customers.data.color
  })
    
  }

}
</script>